import { render } from "./CTAButton.vue?vue&type=template&id=6cf26cd2&scoped=true"
import script from "./CTAButton.vue?vue&type=script&lang=js"
export * from "./CTAButton.vue?vue&type=script&lang=js"

import "./CTAButton.vue?vue&type=style&index=0&id=6cf26cd2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf26cd2"]])

export default __exports__